import { render, staticRenderFns } from "./modifyAddress.vue?vue&type=template&id=b29c474e&"
import script from "./modifyAddress.vue?vue&type=script&lang=ts&"
export * from "./modifyAddress.vue?vue&type=script&lang=ts&"
import style0 from "./modifyAddress.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports